export const CommerceDataCa = {
    form: {
        inputs: {
            name: {
                label: "nom complet*",
                placeholder: "Ex. Maria torres Martínez",
            },
            company: {
                label: "nom empresa*",
                placeholder: "Ex. Ejemplo SL",
            },
            email: {
                label: "correu electrònic",
                placeholder: "Ex. ejemplo@gmail.com",
                error: "Format de correu invàlid*",
            },
            phone: {
                label: "telèfon*",
                placeholder: "Ex. +34 000 000 000",
                error: "Format de telèfon invàlid*",
            },
            type: {
                label: "quin tipus de negoci ets?*",
                type_options: [],
            },
            location: {
                label: "selecciona la ubicació de la teva empresa*",
            },
        },
        button: "Enviar sol·licitud",
    },
    success: {
        message: "El formulari ha estat enviat correctament.",
        button: "Enviar una altra sol·licitud",
    },
    error: {
        message: "Hi va haver un error en enviar la sol·licitud",
        button: "Tornar a intentar",
    },
};
